"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TargetDisplaySize_1 = __importDefault(require("./TargetDisplaySize"));
const VideoQualityAdaptationPreference_1 = __importDefault(require("./VideoQualityAdaptationPreference"));
class VideoPreference {
    /** Initializes a [[VideoPreference]] with the given properties.
     *
     * @param attendeeId Attendee ID of the client
     * @param priority The relative priority of this attendee against others.
     * @param targetSize The desired maximum simulcast layers to receive.
     * @param degradationPreference The preference on how to select between resolution and framerate on network constraint
     */
    constructor(attendeeId, priority, targetSize, degradationPreference) {
        this.attendeeId = attendeeId;
        this.priority = priority;
        this.targetSize = targetSize !== undefined ? targetSize : TargetDisplaySize_1.default.Maximum;
        this.degradationPreference =
            degradationPreference !== undefined
                ? degradationPreference
                : VideoQualityAdaptationPreference_1.default.Balanced;
    }
    partialCompare(other) {
        return this.priority - other.priority;
    }
    equals(other) {
        return (this.attendeeId === other.attendeeId &&
            this.targetSize === other.targetSize &&
            this.priority === other.priority &&
            this.degradationPreference === other.degradationPreference);
    }
    clone() {
        return new VideoPreference(this.attendeeId, this.priority, this.targetSize, this.degradationPreference);
    }
    targetSizeToBitrateKbps(targetSize) {
        switch (targetSize) {
            case TargetDisplaySize_1.default.Maximum:
                return VideoPreference.MAXIMUM_BITRATE_KBPS;
            case TargetDisplaySize_1.default.High:
                return VideoPreference.HIGH_BITRATE_KBPS;
            case TargetDisplaySize_1.default.Medium:
                return VideoPreference.MID_BITRATE_KBPS;
            case TargetDisplaySize_1.default.Low:
                return VideoPreference.LOW_BITRATE_KBPS;
        }
    }
}
exports.default = VideoPreference;
VideoPreference.LOW_BITRATE_KBPS = 300;
VideoPreference.MID_BITRATE_KBPS = 600;
VideoPreference.HIGH_BITRATE_KBPS = 1500;
VideoPreference.MAXIMUM_BITRATE_KBPS = 10000;
//# sourceMappingURL=VideoPreference.js.map